export default __webpack_public_path__ + "static/media/DIR&P.50d28fdf.png";